


import React from "react";
import LogoInfo from "../LogoInfo/LogoInfo";
import TeacherSelectionBar from "../TeacherSelectionBar/TeacherSelectionBar";
import Logout from "../Logout/Logout";
import "./Sidebar.css";

const Sidebar = ({ activePage, setActivePage, isOpen, toggleSidebar }) => {
  return (
    <div className="sidebar-main">
      
      <div
        id="mySidebar"
        className="sidebar"
        style={{ width: isOpen ? "250px" : "0", transition: "0.3s" }}
      >
        <div>
          <LogoInfo />
          {/* TeacherSelectionBar state ilə işləyir */}
          <TeacherSelectionBar activePage={activePage} setActivePage={setActivePage} />
        </div>

        <Logout />
      </div>

      <div
        id="main"
        style={{ marginLeft: isOpen ? "250px" : "0", transition: "0.3s" }}
      >
        <button
          className="openbtn btn btn-light"
          onClick={toggleSidebar}
          style={{
            fontSize: "0.9rem",
            position: "fixed",
            top: "10px",
            left: isOpen ? "250px" : "0",
            zIndex: 1,
            transition: "left 0.3s ease",
          }}
        >
          {isOpen ? <i className="bi bi-chevron-left"></i> : <i className="bi bi-chevron-right"></i>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;